import Axios from "axios";

export const demand = {
  namespaced: true,
  state: {
    selectedService: null,
    demandToken: null,
    busStops: {},
    pickupBusStop: { name: null, id: null },
    dropoffBusStop: { name: null, id: null },
    selectedColumn: "Departure",
    divisionObject: {
      adult: {label:'おとな', count: 1},
      child: {label: 'こども', count: 0},
      infant: {label: '幼児(6歳未満)', count: 0}
    },
    pickUpBusstopId: null,
    dropOffBusstopId: null,
    seatCount: {},
    paymentMethods: null,
    pickUpTime: null,
    tentativeReservation: null,
    Reservation: null,
  },
  getters: {
    selectedService(state) {
      return state.selectedService;
    },
    demandToken(state) {
      return state.demandToken;
    },
    busStops(state) {
      return state.busStops;
    },
    pickupBusStop(state) {
      return state.pickupBusStop;
    },
    dropoffBusStop(state) {
      return state.dropoffBusStop;
    },
    selectedColumn(state) {
      return state.selectedColumn;
    },
    divisionObject(state) {
      return state.divisionObject;
    },
    pickUpBusstopId(state) {
      return state.pickUpBusstopId;
    },
    dropOffBusstopId(state) {
      return state.dropOffBusstopId;
    },
    seatCount(state) {
      return state.seatCount;
    },
    paymentMethods(state) {
      return state.paymentMethods;
    },
    pickUpTime(state) {
      return state.pickUpTime;
    },
    tentativeReservation(state) {
      return state.tentativeReservation;
    },
    Reservation(state) {
      return state.Reservation;
    },
  },
  mutations: {
    setSelectedService(state, selectedService) {
      state.selectedService = selectedService;
    },
    setDemandToken(state, demandToken) {
      state.demandToken = demandToken;
    },
    setBusStops(state, busStops) {
      state.busStops = busStops;
    },
    setPickupBusStop(state, pickupBusStop) {
      state.pickupBusStop = pickupBusStop;
    },
    setDropoffBusStop(state, dropoffBusStop) {
      state.dropoffBusStop = dropoffBusStop;
    },
    setSelectedColumn(state, selectedColumn) {
      state.selectedColumn = selectedColumn;
    },
    setDivisionObject(state, divisionObject) {
      state.divisionObject = divisionObject;
    },
    setPickUpBusstopId(state, pickUpBusstopId) {
      state.pickUpBusstopId = pickUpBusstopId;
    },
    setDropOffBusstopId(state, dropOffBusstopId) {
      state.dropOffBusstopId = dropOffBusstopId;
    },
    setSeatCount(state, seatCount) {
      state.seatCount = seatCount;
    },
    setPaymentMethods(state, paymentMethods) {
      state.paymentMethods = paymentMethods;
    },
    setPickUpTime(state, pickUpTime) {
      state.pickUpTime = pickUpTime;
    },
    setTentativeReservation(state, tentativeReservation) {
      state.tentativeReservation = tentativeReservation;
    },
    setReservation(state, Reservation) {
      state.Reservation = Reservation;
    },
  }
};
